import { useSearchParams } from 'react-router'

import { READER_AT_PARAM } from '@/routes/paths'

/** URL の ?at= で指定された、開いたときに移動する AI 読書アシストの位置キー（EPUB: spine 番号 + 進み具合 / PDF: ページ） */
export const useReaderJumpKey = (): number | null => {
  const [searchParams] = useSearchParams()
  const raw = searchParams.get(READER_AT_PARAM)
  const key = raw == null ? NaN : Number(raw)
  return Number.isFinite(key) && key >= 0 ? key : null
}
